











































import { RouteName } from '@src/app/router/constants/RouteName';
import { SdsFlag } from '@superbet-group/web.lib.ui-components';
import { useVueRouter } from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';
import { useCompetitionsDataSources } from '../competitions/components/useCompetitionsDataSources';
import { getFlagByCategory } from '../flags/flagMapping';
import SdsMobileHeader from '@src/app/mobile/navbar/SdsMobileHeader.vue';

export default defineComponent({
    setup() {
        const { route, router } = useVueRouter();

        const {
            currentCategoryId,
            competitionName,
            categoryName,
            competitionEventsDateRange,
        } = useCompetitionsDataSources();

        const currentCompetitionName = computed(() => {
            return route.value.name === RouteName.Sport.Competition
                ? competitionName.value
                : null;
        });
        const currentCompetitionFlag = computed(() => {
            return currentCategoryId.value ? getFlagByCategory(currentCategoryId.value) : null;
        });

        function navigateToSportCompetitions() {
            router.value.push({
                name: RouteName.Sport.SportCompetitions,
            });
        }

        return {
            currentCompetitionName,
            currentCompetitionFlag,
            categoryName,
            competitionEventsDateRange,
            navigateToSportCompetitions,
        };
    },
    components: {
        SdsMobileHeader,
        SdsFlag,
    },
});
